module.exports = __webpack_public_path__ + "media/images/sales/early/btn-cta-6-ee2ea9c1745b2a3ab5f7584e06a9d1fe.svg";